import { render, staticRenderFns } from "./CompanyRankLocalizationsCard.vue?vue&type=template&id=4e5b3547&scoped=true&"
import script from "./CompanyRankLocalizationsCard.vue?vue&type=script&lang=js&"
export * from "./CompanyRankLocalizationsCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRankLocalizationsCard.vue?vue&type=style&index=0&id=4e5b3547&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b3547",
  null
  
)

export default component.exports